<template>
  <div>
    <v-container
      fluid
      :class="almost_mobile ? 'pt-16 stycard' : 'pt-16 px-10 stycard'"
      style="min-height: 100vh"
    >
      <!-- <div v-show="almost_mobile" style="margin-top: 15%"></div> -->
      <h3 class="pb-2 pt-3 pl-2" style="color: #00a99d; font-size: 25px">
        รายการนัดหมาย
      </h3>

      <v-row
        class="mr-1 my-2 mt-8"
        style="justify-content: center"
        v-if="check_biz_kasemrad == '668236676897760'"
      >
        <v-col
          cols="12"
          md="3"
          sm="6"
          lg="3"
          align-self="center"
          class="pt-0 pr-0"
        >
          <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="activeGet(1)"
            :class="status == 'confirm' ? 'bg-00A99D' : 'bg-CEEFED'"
          >
            <v-row>
              <v-col cols="12" class="d-flex align-center justify-start pl-6">
                <v-img
                  :src="
                    status == 'confirm'
                      ? require('@/assets/icon/Telepharma/all-dark.svg')
                      : require('@/assets/icon/Telepharma/all-light.svg')
                  "
                  class="mr-5 px-3 py-4"
                  :class="status == 'confirm' ? 'icon-dark' : 'icon-light'"
                />
                <v-row>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      v-if="summaryQ !== null && 'confirm' in summaryQ"
                      :class="
                        status == 'confirm' ? 'text-ffffff' : 'text-00a99d'
                      "
                      ><h3>{{ summaryQ.confirm }}</h3></span
                    >
                    <span
                      v-else
                      :class="
                        status == 'confirm' ? 'text-ffffff' : 'text-00a99d'
                      "
                      ><h3>0</h3></span
                    >
                  </v-col>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      :class="
                        status == 'confirm' ? 'text-ffffff' : 'text-00a99d'
                      "
                      >ซักประวัติ</span
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="3"
          sm="6"
          lg="3"
          align-self="center"
          class="pt-0 pr-0"
        >
          <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="activeGet(2)"
            :class="status == 'conference' ? 'bg-00A99D' : 'bg-CEEFED'"
          >
            <v-row>
              <v-col cols="12" class="d-flex align-center justify-start pl-6">
                <v-img
                  :src="require('@/assets/icon/Telepharma/transport.svg')"
                  class="mr-5 pb-2 pa-3"
                  :class="status == 'conference' ? 'icon-dark' : 'icon-light'"
                />
                <v-row>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      v-if="summaryQ !== null && 'conference' in summaryQ"
                      :class="
                        status == 'conference' ? 'text-ffffff' : 'text-00a99d'
                      "
                      ><h3>{{ summaryQ.conference }}</h3></span
                    >
                    <span
                      v-else
                      :class="
                        status == 'conference' ? 'text-ffffff' : 'text-00a99d'
                      "
                      ><h3>0</h3></span
                    >
                  </v-col>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      :class="
                        status == 'conference' ? 'text-ffffff' : 'text-00a99d'
                      "
                      >พบแพทย์</span
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="3"
          sm="6"
          lg="3"
          align-self="center"
          class="pt-0 pr-0"
        >
          <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="activeGet(3)"
            :class="status == 'finish' ? 'bg-00A99D' : 'bg-CEEFED'"
          >
            <v-row>
              <v-col cols="12" class="d-flex align-center justify-start pl-6">
                <v-img
                  :src="require('@/assets/icon/Telepharma/success.svg')"
                  class="mr-5 pb-2 pa-3"
                  :class="status == 'finish' ? 'icon-dark' : 'icon-light'"
                />
                <v-row>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      v-if="summaryQ !== null && 'finish' in summaryQ"
                      :class="
                        status == 'finish' ? 'text-ffffff' : 'text-00a99d'
                      "
                      ><h3>{{ summaryQ.finish }}</h3></span
                    >
                    <span
                      v-else
                      :class="
                        status == 'finish' ? 'text-ffffff' : 'text-00a99d'
                      "
                      ><h3>0</h3></span
                    >
                  </v-col>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      :class="
                        status == 'finish' ? 'text-ffffff' : 'text-00a99d'
                      "
                      >พบแพทย์เสร็จสิ้น</span
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="3"
          sm="6"
          lg="3"
          align-self="center"
          class="pt-0 pr-0"
        >
          <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="activeGet(5)"
            :class="status == 'drug' ? 'bg-00A99D' : 'bg-CEEFED'"
          >
            <v-row>
              <v-col cols="12" class="d-flex align-center justify-start pl-6">
                <v-img
                  :src="require('@/assets/icon/Telepharma/Vector.svg')"
                  class="mr-5 pb-2 pa-3"
                  :class="status == 'drug' ? 'icon-dark' : 'icon-light'"
                />
                <v-row>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      v-if="summaryQ !== null && 'drug' in summaryQ"
                      :class="status == 'drug' ? 'text-ffffff' : 'text-00a99d'"
                      ><h3>{{ summaryQ.drug }}</h3></span
                    >
                    <span
                      v-else
                      :class="status == 'drug' ? 'text-ffffff' : 'text-00a99d'"
                      ><h3>0</h3></span
                    >
                  </v-col>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      :class="status == 'drug' ? 'text-ffffff' : 'text-00a99d'"
                      >พบเภสัชกร</span
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mr-1 my-2 mt-8" style="justify-content: center" v-else>
        <v-col
          cols="12"
          md="3"
          sm="6"
          lg="3"
          align-self="center"
          class="pt-0 pr-0"
        >
          <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="activeGet(1)"
            :class="status == 'confirm' ? 'bg-00A99D' : 'bg-CEEFED'"
          >
            <v-row>
              <v-col cols="12" class="d-flex align-center justify-start pl-6">
                <v-img
                  :src="
                    status == 'confirm'
                      ? require('@/assets/icon/Telepharma/all-dark.svg')
                      : require('@/assets/icon/Telepharma/all-light.svg')
                  "
                  class="mr-5 px-3 py-4"
                  :class="status == 'confirm' ? 'icon-dark' : 'icon-light'"
                />
                <v-row>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      v-if="summaryQ !== null && 'confirm' in summaryQ"
                      :class="
                        status == 'confirm' ? 'text-ffffff' : 'text-00a99d'
                      "
                      ><h3>{{ summaryQ.confirm }}</h3></span
                    >
                    <span
                      v-else
                      :class="
                        status == 'confirm' ? 'text-ffffff' : 'text-00a99d'
                      "
                      ><h3>0</h3></span
                    >
                  </v-col>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      :class="
                        status == 'confirm' ? 'text-ffffff' : 'text-00a99d'
                      "
                      >รายการนัดหมาย</span
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="3"
          sm="6"
          lg="3"
          align-self="center"
          class="pt-0 pr-0"
        >
          <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="activeGet(2)"
            :class="status == 'conference' ? 'bg-00A99D' : 'bg-CEEFED'"
          >
            <v-row>
              <v-col cols="12" class="d-flex align-center justify-start pl-6">
                <v-img
                  :src="require('@/assets/icon/Telepharma/transport.svg')"
                  class="mr-5 pb-2 pa-3"
                  :class="status == 'conference' ? 'icon-dark' : 'icon-light'"
                />
                <v-row>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      v-if="summaryQ !== null && 'conference' in summaryQ"
                      :class="
                        status == 'conference' ? 'text-ffffff' : 'text-00a99d'
                      "
                      ><h3>{{ summaryQ.conference }}</h3></span
                    >
                    <span
                      v-else
                      :class="
                        status == 'conference' ? 'text-ffffff' : 'text-00a99d'
                      "
                      ><h3>0</h3></span
                    >
                  </v-col>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      :class="
                        status == 'conference' ? 'text-ffffff' : 'text-00a99d'
                      "
                      >พบแพทย์</span
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col
          cols="12"
          md="3"
          sm="6"
          lg="3"
          align-self="center"
          class="pt-0 pr-0"
        >
          <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="activeGet(5)"
            :class="status == 'drug' ? 'bg-00A99D' : 'bg-CEEFED'"
          >
            <v-row>
              <v-col cols="12" class="d-flex align-center justify-start pl-6">
                <v-img
                  :src="require('@/assets/icon/Telepharma/Vector.svg')"
                  class="mr-5 pb-2 pa-3"
                  :class="status == 'drug' ? 'icon-dark' : 'icon-light'"
                />
                <v-row>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      v-if="summaryQ !== null && 'drug' in summaryQ"
                      :class="status == 'drug' ? 'text-ffffff' : 'text-00a99d'"
                      ><h3>{{ summaryQ.drug }}</h3></span
                    >
                    <span
                      v-else
                      :class="status == 'drug' ? 'text-ffffff' : 'text-00a99d'"
                      ><h3>0</h3></span
                    >
                  </v-col>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      :class="status == 'drug' ? 'text-ffffff' : 'text-00a99d'"
                      >รับยา</span
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col
          cols="12"
          md="3"
          sm="6"
          lg="3"
          align-self="center"
          class="pt-0 pr-0"
        >
          <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="activeGet(3)"
            :class="status == 'finish' ? 'bg-00A99D' : 'bg-CEEFED'"
          >
            <v-row>
              <v-col cols="12" class="d-flex align-center justify-start pl-6">
                <v-img
                  :src="require('@/assets/icon/Telepharma/success.svg')"
                  class="mr-5 pb-2 pa-3"
                  :class="status == 'finish' ? 'icon-dark' : 'icon-light'"
                />
                <v-row>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      v-if="summaryQ !== null && 'finish' in summaryQ"
                      :class="
                        status == 'finish' ? 'text-ffffff' : 'text-00a99d'
                      "
                      ><h3>{{ summaryQ.finish }}</h3></span
                    >
                    <span
                      v-else
                      :class="
                        status == 'finish' ? 'text-ffffff' : 'text-00a99d'
                      "
                      ><h3>0</h3></span
                    >
                  </v-col>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      :class="
                        status == 'finish' ? 'text-ffffff' : 'text-00a99d'
                      "
                      >จบการรักษา</span
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mx-1 my-2">
        <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="card-search">
          <v-row>
            <v-col cols="12" class="px-2 pt-2 pb-3">
              <v-autocomplete
                class="card-small"
                no-filter
                v-model="itemsMember"
                return-object
                :items="[...findUser]"
                solo
                hide-details
                dense
                @input="getqueue()"
                @keyup="getPatients"
                item-value="value"
                item-text="text"
                color="#00a99d"
                item-color="teal darken-2"
                clearable
                @click:clear="(search = ''), getPatients()"
              >
                <template v-slot:append>
                  <v-btn text icon>
                    <v-icon color="#00A99D">mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <template slot="label">
                  <span class="text-a5a5a5 font-14">ค้นหาชื่อหรือเบอร์โทร</span>
                </template>
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-title> ไม่พบข้อมูล </v-list-item-title>
                  </v-list-item>
                </template>
                <template slot="selection" slot-scope="{ item }">
                  <span>{{ item.text }}</span>
                </template>
                <template slot="item" slot-scope="{ item }">
                  <div class="d-flex flex-column">
                    <span>{{ item.text }}</span>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
        <v-spacer></v-spacer>
        <v-col
          cols="12"
          sm="12"
          md="3"
          lg="3"
          xl="3"
          class="bg-ceefed card-search-start"
        >
          <v-row>
            <v-col cols="12" class="px-2 pt-2">
              <v-autocomplete
                no-filter
                v-model="itemsDoctor"
                @input="getqueue"
                return-object
                :items="[...all_doctor, ...findDoctor]"
                @click="searchAllDoctor"
                @keyup="searchAllDoctor"
                item-text="one_id"
                :disabled="role_name == 'แพทย์'"
                solo
                dense
                hide-details
                height="38"
                class="card-small"
                color="#00a99d"
                item-color="teal darken-2"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-title> ไม่พบข้อมูล </v-list-item-title>
                  </v-list-item>
                </template>
                <template slot="label">
                  <span class="text-a5a5a5 font-14">แพทย์ทั้งหมด</span>
                </template>
                <template slot="selection" slot-scope="{ item }">
                  <span>{{ item.staff_first_name_th }}</span>
                </template>
                <template slot="item" slot-scope="{ item }">
                  <span>{{ item.staff_first_name_th }}</span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="3"
          lg="3"
          xl="3"
          :class="status == 'drug' ? 'bg-ceefed' : 'card-search-end'"
        >
          <v-row>
            <v-col cols="12" class="pa-2">
              <v-menu
                v-model="day_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                bottom
                left
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    solo
                    dense
                    v-model="date_text"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    hide-details
                    class="card-small"
                    color="#00a99d"
                    v-on="on"
                    clearable
                    placeholder="วัน/เดือน/ปี"
                    @click:clear="clearDate"
                    height="38"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filter.time"
                  no-title
                  scrollable
                  locale="th"
                  class="card-small"
                  dense
                  placeholder="วัน-เดือน-ปี"
                  @input="changeDate()"
                >
                </v-date-picker>
              </v-menu>
              <!-- <date-picker
                @change="changeDate"
                value-type="YYYY-MM-DD"
                v-model="filter.time"
                format="DD/MM/YYYY"
                class="card-small"
                dense
                placeholder="วัน-เดือน-ปี"
                color="#00a99d"
              >
              </date-picker> -->
            </v-col>
          </v-row>
        </v-col>
        <v-col
          v-show="status == 'drug'"
          cols="12"
          md="3"
          lg="2"
          class="card-search-end"
        >
          <v-row>
            <v-col cols="12" class="px-2 pt-2 pb-3">
              <v-autocomplete
                no-filter
                v-model="drug_status"
                placeholder="ทั้งหมด"
                solo
                :items="itemStatus"
                hide-details
                @input="getqueue()"
                item-text="text"
                item-value="value"
                class="card-small"
                color="#00a99d"
                item-color="teal darken-2"
              >
                <template v-slot:append>
                  <v-btn text icon> </v-btn>
                </template>
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-title> ไม่พบข้อมูล </v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!--  ui ใหม่ -->
      <v-row class="ma-2 mt-8">
        <v-col cols="12" md="3" lg="3">
          <v-row class="card_pr">
            <v-col
              cols="12"
              class="elevation-1 table-viewdoc"
              style="min-height: 45vh; border-radius: 10px"
            >
              <v-row class="pa-1 ml-2">
                <v-col cols="12" class="py-5 font-20 w-700 text-09425A">
                  <span v-if="status !== 'drug'" style="color: #00a99d"
                    >รายการนัดหมาย</span
                  >
                  <span v-else style="color: #00a99d">รายการรับยา</span>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row class="pa-0 ml-0 mr-0">
                <v-col
                  align="center"
                  cols="12"
                  class="font-20 w-700"
                  v-if="itemsQ.length !== 0"
                >
                  <v-list>
                    <v-list-item-group v-model="selectedItem">
                      <v-list-item
                        v-for="(item, index) in itemsQ"
                        :key="index"
                        class="my-1"
                        style="border: 1px solid #e8e9e9; border-radius: 5px"
                        :value="item._id"
                        @click="slotTime(item)"
                      >
                        <v-list-item-content>
                          <v-list-item-title>
                            <div class="d-flex flex-column" style="">
                              <v-row v-if="item.patient_name.length > 15">
                                <v-col cols="12" class="pb-0 text-left">
                                  <span class="w-500 font-16 mt-2 text-navy-50">
                                    {{ item.patient_name }}
                                  </span>
                                </v-col>
                                <v-col cols="12" class="pb-0 text-right">
                                  <span
                                    :class="`w-500 font-14 mt-2 ${
                                      textstatus(item).color
                                    }`"
                                  >
                                    {{ textstatus(item).text }}
                                  </span>
                                  <span
                                    :class="`w-500 font-14 mt-2 ${
                                      textdrugstatus(status, item).color
                                    }`"
                                  >
                                    {{ textdrugstatus(status, item).text }}
                                  </span>
                                </v-col>
                              </v-row>
                              <v-row v-else>
                                <v-col cols="7" class="pb-0 text-left">
                                  <span class="w-500 font-16 mt-2 text-navy-50">
                                    {{ item.patient_name }}
                                  </span>
                                </v-col>
                                <v-col cols="5" class="text-right">
                                  <span
                                    :class="`w-500 font-14 mt-2 ${
                                      textstatus(item).color
                                    }`"
                                  >
                                    {{ textstatus(item).text }}
                                  </span>
                                  <span
                                    :class="`w-500 font-14 mt-2 ${
                                      textdrugstatus(status, item).color
                                    }`"
                                  >
                                    {{ textdrugstatus(status, item).text }}
                                  </span>
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col cols="4" class="text-left">
                                  <span class="w-500 font-14 mt-2 text-grey-70">
                                    {{ convertBirthDay(item.date) }}
                                  </span>
                                </v-col>
                                <v-col cols="8" class="text-right">
                                  <span class="w-500 font-14 mt-2 text-grey-70">
                                    {{ item.start }} - {{ item.end }} น.
                                  </span>
                                </v-col>
                              </v-row>
                            </div>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>

                  <!-- <v-list dense v-if="status == 'drug'">
                    <v-list-item-group v-model="selectedItem">
                      <v-list-item
                        v-for="(item, index) in itemsQ"
                        :key="index"
                        class="my-1"
                        style="border: 1px solid #e8e9e9; border-radius: 5px"
                        :value="item._id"
                        @click="slotTime(item)"
                      >
                        <v-list-item-content>
                          <v-list-item-title>
                            <div class="d-flex flex-column" style="">
                              <v-row>
                                <v-col cols="12" class="pb-0 text-left">
                                  <span class="w-500 font-16 mt-2 text-navy-50">
                                    {{ item.doctor_name }}
                                  </span>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="6" class="text-left">
                                  <span
                                    :class="`w-500 font-14 mt-2 ${
                                      textstatus(patientDetil.stage, status)
                                        .color
                                    }`"
                                  >
                                    {{
                                      textstatus(patientDetil.stage, status)
                                        .text
                                    }}
                                  </span>

                                  <span
                                    :class="`w-500 font-14 mt-2 ${
                                      textdrugstatus(status, item).color
                                    }`"
                                  >
                                    {{ textdrugstatus(status, item).text }}
                                  </span>
                                </v-col>
                                <v-col cols="6" class="text-right">
                                  <span class="w-500 font-14 mt-2 text-grey-70">
                                    {{ item.start }} - {{ item.end }} น.
                                  </span>
                                </v-col>
                              </v-row>
                            </div>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list> -->

                  <div
                    class="text-center"
                    style="font-size: 14px !important"
                    v-if="queueTotal > 10"
                  >
                    <PaginationSmall
                      :totals="queueTotal"
                      :isPage="page"
                      @page="changePage"
                    />
                  </div>
                </v-col>
                <v-col
                  align="center"
                  cols="12"
                  class="font-20 w-700"
                  style="margin-top: 117px"
                  v-else
                >
                  <span
                    class="w-700 text-navy-50 font-16"
                    style="color: #00a99d"
                    >ไม่มีรายการนัดหมาย</span
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          md="9"
          lg="9"
          class="elevation-1 table-viewdoc"
          style="min-height: 45vh; border-radius: 10px"
          v-if="itemsQ.length !== 0"
        >
          <v-row class="pr-0 pl-0">
            <v-col
              cols="12"
              class="bg-white pl-0 pr-0"
              style="min-height: 45vh; border-radius: 10px"
            >
              <v-row
                class="ml-0 mr-0"
                style="border: 1px solid #e8e9e9; border-radius: 5px"
              >
                <v-col cols="5" class="pa-0">
                  <v-row class="pl-3 pt-1">
                    <v-col
                      cols="12"
                      class="pb-0 pt-5 font-16 w-800 text-09425A"
                    >
                      <span
                        v-if="patientDetil == undefined || patientDetil == ''"
                      >
                        {{ itemsQ[0].patient_name }}
                      </span>
                      <span v-else>
                        {{ patientDetil.patient_name }}
                      </span>
                      <!-- not patientDetil -->
                      <span
                        v-if="
                          (itemsQ[0].status == 'confirm' &&
                            itemsQ[0].payment_success == true &&
                            check_biz_kasemrad !== '668236676897760' &&
                            patientDetil == '') ||
                          patientDetil == undefined
                        "
                        class="text-F9C74F"
                        >รอพบแพทย์</span
                      >
                      <span
                        v-if="
                          (itemsQ[0].status == 'confirm' &&
                            itemsQ[0].payment_success == true &&
                            check_biz_kasemrad == '668236676897760' &&
                            patientDetil == '') ||
                          patientDetil == undefined
                        "
                        class="text-336AB4"
                        >ซักประวัติ</span
                      >
                      <span
                        v-if="
                          (itemsQ[0].status == 'confirm' &&
                            itemsQ[0].payment_success == false &&
                            patientDetil == '') ||
                          patientDetil == undefined
                        "
                        class="text-F9C74F"
                        >รอชำระเงิน</span
                      >
                      <span
                        v-if="
                          (itemsQ[0].status == 'conference' &&
                            patientDetil == '') ||
                          patientDetil == undefined
                        "
                        class="text-336AB4"
                        >พบแพทย์</span
                      >
                      <span
                        v-if="
                          (itemsQ[0].status == 'drug' && patientDetil == '') ||
                          patientDetil == undefined
                        "
                        class="text-FFA07A"
                        >รอรับยา</span
                      >
                      <span
                        v-if="
                          (itemsQ[0].status == 'finish' &&
                            patientDetil == '') ||
                          patientDetil == undefined
                        "
                        class="text-43AA8B"
                        >จบการรักษา</span
                      >
                      <!-- have patientDetil -->
                      <span
                        v-if="
                          patientDetil.status == 'confirm' &&
                          patientDetil.payment_success == true &&
                          check_biz_kasemrad !== '668236676897760' &&
                          patientDetil !== ''
                        "
                        class="text-F9C74F"
                        >รอพบแพทย์</span
                      >
                      <span
                        v-if="
                          patientDetil.status == 'confirm' &&
                          patientDetil.payment_success == true &&
                          check_biz_kasemrad == '668236676897760' &&
                          patientDetil !== ''
                        "
                        class="text-336AB4"
                        >ซักประวัติ</span
                      >
                      <span
                        v-if="
                          patientDetil.status == 'confirm' &&
                          patientDetil.payment_success == false &&
                          patientDetil !== ''
                        "
                        class="text-F9C74F"
                        >รอชำระเงิน</span
                      >
                      <span
                        v-if="
                          patientDetil.status == 'conference' &&
                          patientDetil !== ''
                        "
                        class="text-336AB4"
                        >พบแพทย์</span
                      >
                      <span>
                        <span
                          v-if="
                            patientDetil.status == 'drug' && patientDetil !== ''
                          "
                          class="text-FFA07A"
                          >รอรับยา</span
                        >
                      </span>
                      <span
                        v-if="
                          patientDetil.status == 'drug' &&
                          patientDetil !== '' &&
                          itemHistory &&
                          itemHistory.status_drug == 'return'
                        "
                        class="text-336AB4"
                      >
                        (ส่งคืนเเก้ไขยา)</span
                      >
                      <span
                        v-if="
                          patientDetil.status == 'drug' &&
                          patientDetil !== '' &&
                          itemHistory &&
                          itemHistory.status_drug == 'pending'
                        "
                        class="text-336AB4"
                      >
                        (รอตรวจสอบยา)</span
                      >
                      <span
                        v-if="
                          patientDetil.status == 'drug' &&
                          patientDetil !== '' &&
                          itemHistory &&
                          itemHistory.status_drug == 'confirm'
                        "
                        class="text-336AB4"
                      >
                        (ตรวจสอบยาเสร็จสิ้น)</span
                      >
                      <span
                        v-if="
                          patientDetil.status == 'finish' && patientDetil !== ''
                        "
                        class="text-43AA8B"
                        >จบการรักษา</span
                      >
                    </v-col>
                  </v-row>
                  <!-- date time -->
                  <v-row class="pl-3 pt-0">
                    <v-col
                      cols="12"
                      class="pb-0 pt-0 pb-8"
                      v-if="patientDetil == undefined || patientDetil == ''"
                    >
                      <span class="font-14 mt-1">
                        {{ momentDate(itemsQ[0].date) }}
                      </span>
                      <span class="font-14 mt-1">
                        เวลา
                        {{ itemsQ[0].start }}
                        -
                        {{ itemsQ[0].end }}
                        น.
                      </span>
                    </v-col>
                    <v-col v-else cols="12" class="pt-0 pb-8">
                      <span class="font-14 mt-1">
                        {{ momentDate(patientDetil.date) }}
                      </span>
                      <span class="font-14 mt-1">
                        เวลา
                        {{ patientDetil.start }}
                        -
                        {{ patientDetil.end }}
                        น.
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="7" class="pr-3 text-right" align-self="center">
                  <v-btn
                    v-if="
                      status == 'confirm' &&
                      patientDetil.payment_success == true &&
                      check_biz_kasemrad == '668236676897760'
                    "
                    depressed
                    dark
                    color="#838B8B"
                    class="pa-6"
                    @click="Skip(patientDetil)"
                  >
                    <v-icon>mdi mdi-page-next-outline</v-icon>
                    <span
                      class="pl-2 font-14"
                      style="text-transform: capitalize"
                      >ข้ามการซักประวัติ</span
                    >
                  </v-btn>
                  <v-btn
                    v-if="
                      status == 'confirm' &&
                      patientDetil.payment_success == true &&
                      check_biz_kasemrad !== '668236676897760'
                    "
                    depressed
                    dark
                    color="#00A99D"
                    class="pa-6 ml-2"
                    @click="checkIn(patientDetil)"
                  >
                    <v-icon>mdi mdi-video-outline</v-icon>
                    <span
                      class="pl-2 font-14"
                      style="text-transform: capitalize"
                      >ส่งเข้า Conference</span
                    >
                  </v-btn>
                  <v-btn
                    v-if="
                      status == 'confirm' &&
                      patientDetil.payment_success == true &&
                      check_biz_kasemrad == '668236676897760' &&
                      (this.role_name == 'เจ้าหน้าที่' ||
                        this.role_name == 'พยาบาล')
                    "
                    depressed
                    dark
                    color="#00A99D"
                    class="pa-6 ml-2"
                    @click="PhysicalExamOpen(patientDetil)"
                  >
                    <v-icon>mdi mdi-video-outline</v-icon>
                    <span
                      class="pl-2 font-14"
                      style="text-transform: capitalize"
                      >เริ่มการซักประวัติ</span
                    >
                  </v-btn>
                  <v-btn
                    v-if="
                      status == 'conference' &&
                      this.role_name == 'แพทย์' &&
                      check_conference(patientDetil.date)
                    "
                    depressed
                    dark
                    color="#00A99D"
                    class="pa-6"
                    @click="PhysicalExamOpen(patientDetil)"
                  >
                    <!-- <v-img
                      :src="require('@/assets/icon/icon-video-w.png')"
                      style="hight: 20px !important; width: 20px !important"
                    /> -->
                    <v-icon>mdi mdi-video-outline</v-icon>
                    <span
                      class="pl-2 font-14"
                      style="text-transform: capitalize"
                      >Conference</span
                    >
                  </v-btn>
                  <!-- <v-btn
                    v-if="
                      status == '' &&
                      status == '' &&
                      this.role_name == 'เภสัชกร' &&
                      'drugs' in patientDetil &&
                      patientDetil.drugs.status == '1'
                    "
                    depressed
                    dark
                    color="#00A99D"
                    class="pa-6"
                    @click="seeingPharmaNew(patientDetil)"
                  >
                    <v-img
                      :src="require('@/assets/icon/icon-video-w.png')"
                      style="hight: 20px !important; width: 20px !important"
                    />
                    <span
                      v-show="showtextConference(isBreakpoint)"
                      class="pl-2 font-14"
                      style="text-transform: capitalize"
                      >Conference</span
                    >
                  </v-btn> -->
                  <!-- <v-btn
                    v-if="patientDetil.status == 'finish' && status !== 'drug'"
                    depressed
                    :dark="false"
                    color="#00A99D"
                    class="pa-6"
                    :disabled="patientDetil.doc_medcers_status"
                    @click="createFileMedical(patientDetil)"
                  >
                    <v-img
                      :src="require('@/assets/icon/file_medical.png')"
                      style="hight: 20px !important; width: 20px !important"
                    />
                    <span
                      v-show="showtextConference(isBreakpoint)"
                      class="pl-2 font-14 text-white"
                      style="text-transform: capitalize"
                      >ออกใบรับรองแพทย์</span
                    >
                  </v-btn> -->
                  <v-btn
                    v-if="shouldShowDrugAction(itemHistory, status, biz_id)"
                    depressed
                    dark
                    color="#00A99D"
                    class="pa-6 ml-2"
                    @click="PharmacistOpen(patientDetil)"
                  >
                    <!-- <v-img
                      :src="require('@/assets/icon/icon-video-w.png')"
                      style="hight: 20px !important; width: 20px !important"
                    /> -->
                    <v-icon>mdi mdi-video-outline</v-icon>
                    <span
                      class="pl-2 font-14"
                      style="text-transform: capitalize"
                      >Conference</span
                    >
                  </v-btn>
                  <v-btn
                    v-if="shouldShowDrugAction(itemHistory, status, biz_id)"
                    depressed
                    :dark="false"
                    color="#EB5757"
                    class="pa-6 ml-2"
                    @click="sendEditDrugDialog(patientDetil)"
                  >
                    <span
                      v-show="showtextConference(isBreakpoint)"
                      class="pl-2 font-14 text-white"
                      style="text-transform: capitalize"
                      >ส่งคืนแก้ไข</span
                    >
                  </v-btn>
                  <v-btn
                    v-if="shouldShowDrugAction(itemHistory, status, biz_id)"
                    depressed
                    :dark="false"
                    color="#00A99D"
                    class="pa-6 ml-2"
                    :disabled="false"
                    @click="ConfirmDrugDeliveryDialog(patientDetil)"
                  >
                    <span
                      class="pl-1 font-14 text-white"
                      style="text-transform: capitalize"
                      >ยืนยันการส่งยา</span
                    >
                  </v-btn>
                  <!-- <v-btn
                    v-if="
                      status === 'finish' &&
                      this.role_name === 'แพทย์' &&
                      !itemsQ[0].med_cert
                    "
                    depressed
                    :dark="false"
                    color="#00A99D"
                    class="pa-6 ml-2"
                    :disabled="false"
                    @click="get_data_cert(patientDetil)"
                  >
                    <span
                      class="pl-1 font-14 text-white"
                      style="text-transform: capitalize"
                      >ออกใบรับรองแพทย์</span
                    >
                  </v-btn> -->
                </v-col>
              </v-row>
              <v-row class="pl-0 pr-0 ml-0 mr-0">
                <v-col cols="12" class="font-20 w-700 pb-2 pr-0 pl-0">
                  <v-tabs
                    color="#09425A"
                    v-model="tab"
                    @change="changeComponent"
                    show-arrows
                  >
                    <v-tabs-slider color="#63C9D8"></v-tabs-slider>
                    <v-tab
                      v-if="
                        (status == 'conference' || status == 'finish') &&
                        check_biz_kasemrad == '668236676897760'
                      "
                      href="#HistoryTakingKasemrad"
                      align="center"
                      class="font-16 w-700"
                    >
                      ข้อมูลการซักประวัติ</v-tab
                    >
                    <v-tab
                      href="#HistoryTalkingMain"
                      align="center"
                      class="font-16 w-700"
                    >
                      บันทึกสุขภาพ</v-tab
                    >
                    <v-tab
                      href="#MedicalHistoryMain"
                      align="center"
                      class="font-16 w-700"
                    >
                      ประวัติการรักษา</v-tab
                    >

                    <v-tab
                      href="#MedicinePatient"
                      align="center"
                      class="font-16 w-700"
                      v-if="status == 'drug' || status == 'finish'"
                    >
                      ข้อมูลการรับยา</v-tab
                    >
                  </v-tabs>

                  <v-divider></v-divider>
                  <v-tabs-items v-model="tab">
                    <v-tab-item v-for="i in itemTab" :key="i" :value="i">
                      <v-card scrollable>
                        <component
                          :is="i"
                          :reset="reset"
                          @update="activeGet(5)"
                        />
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-col>
                <!-- -------------------------------------------------------------------------------------------------------------------------- -->

                <!-- --------------------------------------------------------------------------- -->
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          md="9"
          lg="9"
          class="elevation-1 table-viewdoc"
          style="min-height: 45vh; border-radius: 10px"
          v-else
        >
          <v-col class="pa-1 text-center" style="margin-top: 150px">
            <span class="w-700 text-navy-50 font-32" style="color: #00a99d"
              >ไม่มีรายการนัดหมาย</span
            >
          </v-col>
        </v-col>
      </v-row>

      <v-dialog v-model="addAppointmentDialog" width="500" max-height="auto">
        <v-card>
          <v-container class="d-flex">
            <span class="w-500 font-24">เพิ่มนัดหมาย</span>
            <v-spacer></v-spacer>
            <v-avatar size="12px">
              <img
                width="60"
                height="60"
                src="@/assets/icon/x.png"
                alt="x"
                @click="resetData"
              />
            </v-avatar>
          </v-container>
          <v-container>
            <span class="font-18 w-500"
              >ชื่อคนไข้<span style="color: red">*</span></span
            >
            <v-autocomplete
              no-filter
              item-value="_id"
              :items="findMember"
              solo
              placeholder="ค้นหาคนไข้"
              class="mb-3"
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-title> ไม่พบข้อมูล </v-list-item-title>
                </v-list-item>
              </template>
              <template slot="item" slot-scope="{ item }">
                <span>{{ item.firstName }} {{ item.lastName }}</span>
              </template>
              <template slot="selection" slot-scope="{ item }">
                <span>{{ item.firstName }} {{ item.lastName }}</span>
              </template>
              <v-icon slot="append"> mdi-magnify </v-icon>
            </v-autocomplete>
            <span class="font-18 w-500"
              >ชื่อแพทย์<span style="color: red">*</span></span
            >
            <v-autocomplete
              solo
              item-value="_id"
              item-text="firstName"
              hide-details="auto"
              placeholder="ค้นหาแพทย์"
              type="text"
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-title> ไม่พบข้อมูล </v-list-item-title>
                </v-list-item>
              </template>
              <v-icon slot="append"> mdi-magnify </v-icon>
            </v-autocomplete>
            <v-row>
              <v-col cols="4" class="d-flex flex-column mt-3">
                <span>วันที่นัด<span style="color: red">*</span></span>

                <date-picker valueType="format" class="set-border-calendar" />
              </v-col>
              <v-col cols="4" class="d-flex flex-column mt-3">
                <span>เวลาเริ่มต้น</span>
                <vue-timepicker class="set-border-calendar pr-6" />
              </v-col>
              <v-col cols="4" class="d-flex flex-column mt-3">
                <span>เวลาสิ้นสุด</span>
                <vue-timepicker class="set-border-calendar pr-6" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card-text class="text-center">
                  <v-row> บริการ </v-row>
                  <v-row>
                    <v-text-field
                      hide-details="auto"
                      placeholder="เลือกบริการ"
                      solo
                    ></v-text-field>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card-text class="text-center">
                  <v-row> สาเหตุที่นัดหมาย </v-row>
                  <v-row>
                    <v-text-field
                      placeholder="ใส่รายละเอียด"
                      hide-details="auto"
                      solo
                    ></v-text-field>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card-text class="text-center">
                  <v-row> การเตรียมตัวก่อนพบแพทย์ </v-row>
                  <v-row>
                    <v-text-field
                      placeholder="ใส่รายละเอียด"
                      solo
                      hide-details="auto"
                    ></v-text-field>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
          <v-card-text class="text-center"> </v-card-text>
          <v-card-actions class="d-flex justify-center">
            <v-row class="pa-0 ma-0">
              <v-col class="pl-0 py-0">
                <v-btn
                  outlined
                  block
                  color="primary"
                  style="background: #fff; color: #5f676b"
                >
                  ยกเลิก
                </v-btn>
              </v-col>
              <v-col class="pr-0 py-0">
                <v-btn block style="background: #238ef2; color: #fff">
                  บันทึก
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="changeStatusAppointment" width="400">
        <v-card>
          <v-card-text
            class="d-flex flex-column justify-center align-center pb-3 pt-5"
          >
            <v-avatar size="100px" class="mb-3">
              <img alt="Avatar" :src="require('@/assets/icon/Succes_G.png')" />
            </v-avatar>
            <h2 style="color: #238ef2">ท่านต้องการยืนยันการนัดหมายหรือไม่</h2>
            <!-- <span>หากท่านยืนยัน รายการนี้จะถูกยกเลิก</span> -->
          </v-card-text>

          <v-card-actions class="d-flex justify-center pb-5">
            <v-btn
              outlined
              color="primary"
              @click="cancelAppointment = false"
              style="background: #fff; color: #5f676b"
            >
              ยกเลิก
            </v-btn>
            <v-btn
              @click="putStatus(statusPut, idPut)"
              style="background: #238ef2; color: #fff"
            >
              ยืนยัน
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- editappoint -->
      <v-dialog v-model="editAppointmentDialog" width="500" max-height="auto">
        <v-card>
          <v-container class="d-flex">
            <span class="w-500 font-24">แก้ไขนัดหมาย</span>
            <v-spacer></v-spacer>
            <v-avatar size="12px">
              <img alt="Avatar" :src="require('@/assets/icon/x.png')" />
            </v-avatar>
          </v-container>
          <v-container>
            <span class="font-18 w-500"
              >ชื่อคนไข้<span style="color: red">*</span></span
            >
            <v-text-field
              hide-details="auto"
              placeholder="เลือกบริการ"
              solo
              readonly
            ></v-text-field>
            <span class="font-18 w-500"
              >ชื่อแพทย์<span style="color: red">*</span></span
            >
            <v-text-field
              hide-details="auto"
              placeholder="เลือกบริการ"
              solo
              readonly
            ></v-text-field>
            <v-row>
              <v-col cols="4" class="d-flex flex-column mt-3">
                <span>วันที่นัด<span style="color: red">*</span></span>
                <date-picker
                  valueType="format"
                  disabled
                  class="set-border-calendar"
                />
              </v-col>
              <v-col cols="4" class="d-flex flex-column mt-3">
                <span>เวลาเริ่มต้น</span>
                <vue-timepicker disabled class="set-border-calendar pr-6" />
              </v-col>
              <v-col cols="4" class="d-flex flex-column mt-3">
                <span>เวลาสิ้นสุด</span>
                <vue-timepicker disabled class="set-border-calendar pr-6" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card-text class="text-center">
                  <v-row> บริการ </v-row>
                  <v-row>
                    <v-text-field
                      readonly
                      hide-details="auto"
                      placeholder="เลือกบริการ"
                      solo
                    ></v-text-field>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card-text class="text-center">
                  <v-row> สาเหตุที่นัดหมาย </v-row>
                  <v-row>
                    <v-text-field
                      readonly
                      placeholder="ใส่รายละเอียด"
                      hide-details="auto"
                      solo
                    ></v-text-field>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card-text class="text-center">
                  <v-row> การเตรียมตัวก่อนพบแพทย์ </v-row>
                  <v-row>
                    <v-text-field
                      readonly
                      placeholder="ใส่รายละเอียด"
                      solo
                      hide-details="auto"
                    ></v-text-field>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
          <v-card-text class="text-center"> </v-card-text>
          <v-card-actions class="d-flex justify-center">
            <v-row class="pa-0 ma-0">
              <v-col class="pl-0 py-0">
                <v-btn
                  outlined
                  block
                  color="primary"
                  @click="editAppointmentDialog = false"
                  style="background: #fff; color: #5f676b"
                >
                  ปิด
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ออกใบรับรองแพทย์ -->
      <v-dialog v-model="loading_dialog" hide-overlay persistent width="300">
        <v-card color="#4EBCA6" dark class="pt-1">
          <v-card-text class="text-center">
            {{ text_loading }}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="med_cert_dialog" scrollable width="500" hide-overlay>
        <v-card class="pa-0 ma-0">
          <v-card-title style="background-color: #00a99d; color: white">
            ออกใบรับรองแพทย์
            <v-spacer></v-spacer>
            <v-btn color="white" icon @click="med_cert_dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-col cols="12">
              <div class="d-flex">
                <v-checkbox
                  v-model="enabled_other"
                  hide-details
                  class="shrink mt-0 mb-1"
                  color="#00A99D"
                ></v-checkbox>
                <span class="mt-1" style="font-size: 14px"> โรคอื่น ๆ </span>
              </div>
              <v-text-field
                v-model="patient_med_cert.other"
                color="#00A99D"
                outlined
                dense
                hide-details
                :disabled="!enabled_other"
                :style="
                  enabled_other
                    ? ''
                    : 'background-color: #E8E9E9; height: 100%;'
                "
                class="mt-1"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <span>สรุปความเห็นและข้อแนะนําของแพทย์</span>
              <v-textarea
                auto-grow
                hide-details
                rows="4"
                row-height="30"
                color="#00A99D"
                outlined
                v-model="patient_med_cert.summary"
                class="mt-1"
              ></v-textarea>
            </v-col>
          </v-card-text>
          <v-card-actions>
            <v-col align="center">
              <v-btn
                @click="med_cert_dialog = false"
                class="card-medium-cancel"
                color="#F2225D"
                outlined
                >ยกเลิก</v-btn
              >
              <v-btn
                @click="add_med_cert"
                class="card-medium ml-5"
                color="#00A99D"
                style="color: white"
                >ตกลง</v-btn
              >
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <SendEditMedicine ref="SendEditMedicine" @close="getqueue" />
      <ConfirmDrugDelivery ref="ConfirmDrugDelivery" @close="getqueue" />
      <!----สั่งยา------------->
      <!-- <ModalDrug ref="dialogDrug" /> -->

      <!----ชักประวัติ------------->
      <MedicalHistor />
      <!----พบแพทย์------------->
      <ConferenceKasemrad
        ref="ConferenceKasemrad"
        @success="activeGet(3)"
        @success_con="activeGet(2)"
        @back="activeGet(2)"
        @back_con="activeGet(1)"
      />
      <ConferenceTelemed
        ref="ConferenceTelemed"
        @success="activeGet(3)"
        @success_drug="activeGet(5)"
        @back="activeGet(2)"
        @Pharmacy_back="activeGet(5)"
      />
      <!----พบเภสัชกร------------->
      <!-- <SeeingPharma
        ref="seeingPharma"
        :dataOnSeeingPharma="seeingPharma"
        :item="itemSeeingPharma"
        @success="successCon"
        @back="activeGet(3)"
      /> -->
      <DeleteAppointment :dataOn="textDialog" />
      <!-- <conference ref="conference" /> -->
      <ModalSuccess />

      <v-dialog v-model="LoadingData" persistent width="300">
        <v-card color="#00a99d" dark>
          <v-card-text>
            <div style="text-align: center">กำลังเชื่อมต่อข้อมูล</div>
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar"
        top
        right
        timeout="2000"
        :color="snackbarColor"
      >
        <span class="text-navy-50">{{ snackbarText }}</span>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import config from "@/views/telemed/json_temp/appointment.json";
import { mapState, mapGetters } from "vuex";
// import data from '@/data/temp_appointment.json'
// import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue2-datepicker/locale/th";
// import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
import {
  MedicalHistor,
  HistoryTalking,
  MedicalHistory,
  HistoryTalkingMain,
  MedicalHistoryMain,
  MedicalCertificate,
  SendEditMedicine,
  ConfirmDrugDelivery,
  MedicinePatient,
  ConferenceKasemrad,
  ConferenceTelemed,
  HistoryTakingKasemrad,
} from "@/components/dialog/index.js";
import { DeleteAppointment, ModalSuccess } from "@/components/modal/index.js";
import { PaginationSmall } from "@/components/pagination/";
import Swal from "sweetalert2";
import { EventBus } from "../../EventBus";
import moment from "moment";
import { mapMutations } from "vuex";
import functioncryto from "@/services/encrypt.js";

export default {
  components: {
    // DatePicker,
    // VueTimepicker,
    // DeleteAppointment,
    // ModalVaccine,
    // ModalSuccess,
    // PaginationSmall,
    // ModalDrug,
    ConferenceKasemrad,
    ConferenceTelemed,
    MedicalHistor,
    DeleteAppointment,
    // PersonalPatientDialog,
    ModalSuccess,
    HistoryTalking,
    MedicalHistory,
    HistoryTalkingMain,
    MedicalHistoryMain,
    PaginationSmall,
    MedicalCertificate,
    SendEditMedicine,
    ConfirmDrugDelivery,
    MedicinePatient,
    HistoryTakingKasemrad,
  },
  data() {
    return {
      isReadonly: false,
      dateVal: moment(new Date())
        .locale("th")
        .add(543, "year")
        .format("DD/MM/YYYY"),
      drug_status: "",
      itemStatus: [
        { value: "", text: "ทั้งหมด" },
        { value: "1", text: "รอตรวจสอบยา" },
        { value: "2", text: "ส่งคืนแก้ไขยา" },
      ],
      valuelist: "",
      itemsQ: [],
      status: "confirm",
      sum: [],
      medicineList: [],
      LoadingData: false,
      itemsDoctor: null,
      itemsMember: null,
      // summaryQ: { all: 0, appointment: 0, waiting: 0, paid: 0, takedrug: 0 },
      summaryQ: { confirm: 0, conference: 0, drug: 0, finish: 0 },
      snackbar: false,
      snackbarText: "",
      snackbarColor: "#FFC259",
      itemAppointment: [],
      editParamAppointment: {},
      canedit: false,
      enabled_other: false,
      med_cert_dialog: false,
      dialog_open: false,
      loading_dialog: false,
      text_loading: "",
      patient_med_cert: {},
      headers: [
        {
          text: "ลำดับ",
          align: "start",
          value: "number",
        },
        {
          text: "รายการยา",
          align: "start",
          value: "medicine_name",
        },
        {
          text: "จำนวน",
          align: "start",
          value: "quantity",
        },
        {
          text: "ราคา",
          align: "start",
          value: "price",
        },
        {
          text: "ราคารวม",
          align: "start",
          value: "total",
        },
      ],

      takingMedicine: [
        {
          medicine: null,
          medicine_name: "",
          quantity: "",
          price: "",
          total: "",
        },
        {
          medicine: null,
          medicine_name: "",
          quantity: "",
          price: "",
          total: "",
        },
        {
          medicine: null,
          medicine_name: "",
          quantity: "",
          price: "",
          total: "",
        },
      ],

      itemTab: [
        // "HistoryTalking",
        // "MedicalHistory",
        "MedicinePatient",
        "HistoryTalkingMain",
        "MedicalHistoryMain",
        "HistoryTakingKasemrad",
      ],
      day_menu: false,
      date_text: "",
      filter: {
        key: "",
        status: "",
        member: "",
        doctorId: "",
        time: moment(new Date()).format("YYYY-MM-DD"),
      },
      paramAppointment: {
        memberId: "",
        doctorId: "",
        // clinicId: this.$cookies.get('me').clinicId,
        time: moment(new Date()).format("YYYY-MM-DD"),
        startTime: "",
        endTime: "",
        service: "",
        reason: "",
        prepare: "",
      },
      page: 1,
      config,
      text: "",
      rules: {
        selectA: [(v) => !!v || "กรุณาเลือกผู้ใช้บริการ"],
        selectB: [(v) => !!v || "กรุณาเลือกแพทย์"],
        selectC: [(v) => !!v || "กรุณาเลือกประเภท"],
        selectD: [(v) => !!v || "กรุณาเลือกบริการ"],
        selectE: [(v) => !!v || "กรุณาเลือกห้อง"],
        selectF: [(v) => !!v || "กรุณาเลือกวันที่นัด"],
        selectG: [(v) => !!v || "กรุณาเลือกเวลาเริ่มต้น"],
        selectH: [(v) => !!v || "กรุณาเลือกเวลาสิ้นสุด"],
      },
      all_doctor: [
        { _id: "all", staff_first_name_th: "แพทย์ทั้งหมด", one_id: "" },
      ],
      all_user: [{ _id: "all", first_name_th: "ผู้ป่วยทั้งหมด", one_id: "" }],
      addAppointmentDialog: false,
      editAppointmentDialog: false,
      addAppointment: false,
      cancelAppointment: false,

      changeStatusAppointment: false,

      findMember: [],
      findDoctor: [],
      statusPut: "",
      idPut: "",
      findUser: [],
      seeingDocData: { conference: "" },
      itemSeeingDoc: { tempData: "" },
      seeingPharma: { conference: "" },
      itemSeeingPharma: { tempData: {} },
      textDialog: { title: "", text: "", type: "" },
      countData: 0,
      countData1: 0,
      countData2: 0,
      searchKey: "",
      searchDoc: "",
      doc_name: "",
      currentDentist: [],
      role_name: sessionStorage.role_name,
      acc_id: sessionStorage.account_id,
      check_biz_kasemrad: sessionStorage.biz_id,
      biz_id: sessionStorage.biz_id,
      patient_id: "",

      den_id: "",
      numStatus: 0,
      queueTotal: 0,

      //  new
      tab: "",
      selectedItem: [],
      itemDrug: [],
      itemHistory: [],
      total: 0,
      patientDetil: [],
      reset: false,
      tabPage: "",

      // ใบรับรองแพทย์
      openFileMedical: false,
      comment: "",
      createFileMedicalItem: {},
      downloadPDF_statue: false,
      itemDownload: [
        {
          text: "ใบรับรองแพทย์",
        },
        {
          text: "ใบรับรองแพทย์",
        },
      ],

      // D-health
      from_redirect: false,
    };
  },
  created() {
    var year1 = "";
    var year2 = "";
    this.filter.time = moment().format("YYYY-MM-DD");
    year1 = moment(this.filter.time).locale("th").format("YYYY");
    year2 = (parseInt(year1) + 543).toString();
    this.date_text = moment(this.filter.time)
      .locale("th")
      .format("DD/MM/" + year2);
    localStorage.setItem("isCapture", true);
  },
  async mounted() {
    this.LoadingData = true;
    setTimeout(() => {
      this.LoadingData = false;
    }, 2000);
    var from = this.$route.query["from"] || "";
    if (from == "redirectDhealth") {
      this.from_redirect = true;
    }
    if (this.role_name == "แพทย์") {
      //this.itemsDoctor = this.acc_id;
      this.itemsDoctor = { one_id: this.acc_id };
    }
    // this.getDoc();
    EventBus.$on("searchNotification", (item) => {
      this.status =
        item == "appointment"
          ? "confirm"
          : item == "confirm_drug" ||
            item == "return_drug" ||
            item == "check_drug"
          ? "drug"
          : "finish";
      this.getPatients();
      this.searchAllDoctor();
    });
    if (this.type_notification) {
      this.status =
        this.type_notification.type == "appointment"
          ? "confirm"
          : this.type_notification.type == "confirm_drug" ||
            this.type_notification.type == "return_drug" ||
            this.type_notification.type == "check_drug"
          ? "drug"
          : "finish";
      this.getPatients();
      this.searchAllDoctor();
    }
    this.getPatients();
    this.searchAllDoctor();
    if (this.$route.query["from"] == "redirect") {
      // this.tab = "HistoryTalkingMain";
      // this.status = "2"
      // this.page = 1
      this.activeGet(2);
      // this.getqueue();
    } else {
      this.getqueue();
    }
    // this.getDrugList();
    await this.getqueue();
    // await this.summaryQ();
  },
  computed: {
    ...mapGetters(["bizId"]),
    ...mapState(["type_notification"]),
    almost_mobile() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
    ...mapGetters({
      permiss: "permissionsGetter" || {},
      items: "setPatientIdGetter" || "",
    }),
    isBreakpoint() {
      return this.$vuetify.breakpoint.name;
    },
  },
  watch: {
    searchKey(v) {
      // console.log(v)
      v !== null
        ? (this.patient_id = v.oneid)
        : v === null
        ? this.getAppointment()
        : (this.patient_id = "");
      this.searchMember(v.first_name_th);
    },
    searchDoc(v) {
      // console.log(v)
      v !== null
        ? (this.den_id = v.dentist_id)
        : v === null
        ? this.getAppointment()
        : (this.den_id = "");
      this.searchDoctor(v.dentist_name);
    },
  },
  beforeDestroy() {
    EventBus.$off("searchNotification");
    this.clearStateNotificationType();
  },
  methods: {
    ...mapMutations([
      "setDetailConference",
      "setQueueConference",
      "setQueueDetail",
      "setItemDrug",
      "setItemHistory",
      "setTotal",
      "setAppointmentDetail",
      "clearStateNotificationType",
      "setHistoryTaking",
    ]),
    // handleInput(value) {
    //   this.itemsMember = value;
    //   if (value) {
    //     this.isReadonly = true;
    //     this.getqueue();
    //   }
    // },
    clearable() {
      this.isReadonly = false;
    },
    checkRole() {
      if (this.status === 5) {
        switch (this.role_name) {
          case "แพทย์":
            return false;
          case "เภสัชกร":
            if (
              "drugs" in this.patientDetil &&
              this.patientDetil.drugs.status == 3
            ) {
              return false;
            } else {
              return true;
            }
        }
      } else {
        return false;
      }
    },
    addTakingMedicine() {
      this.takingMedicine.push({
        medicine: null,
        medicine_name: "",
        quantity: "",
        price: "",
        total: "",
      });
    },
    clearMedicine(index) {
      this.takingMedicine[index].medicine = null;
      this.takingMedicine[index].medicine_name = "";
      this.takingMedicine[index].quantity = "";
      this.takingMedicine[index].price = "";
    },

    quantityTakingMedicine(item) {
      let quantity = 0;
      let chackMedicineError = false;
      item.forEach((ele) => {
        if (ele.medicine_name !== "" && ele.quantity !== "") {
          quantity++;
        }
        if (
          (ele.medicine_name !== "" && ele.quantity == "") ||
          (ele.medicine_name == "" && ele.quantity !== "")
        ) {
          chackMedicineError = true;
        }
      });
      this.medicineError = chackMedicineError;
      return quantity;
    },

    convertBirthDay(date) {
      let datetime = new Date(
        new Date(date) - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, -1)
        .substr(0, 10);
      var [year, month, day] = datetime.split("-");
      return `${day}/${month}/${parseInt(year) + 543}`;
      // return moment(date).format("DD/MM/YYYY");
    },
    calculateAge(date = "") {
      const y = Math.floor(moment.duration(moment().diff(date)).asYears());
      return `${y} ปี `;
    },
    convertDate(time = "") {
      return moment(time).locale("th").add(543, "year").format("DD/MM/YYYY");
    },
    momentDate(date) {
      // console.log(date_diagnotic);
      var year1 = moment(date).locale("th").format("YYYY");
      var year2 = (parseInt(year1) + 543).toString();
      return moment(date)
        .locale("th")
        .format("DD MMMM " + year2);
    },
    priceTakingMedicine(quantity, price) {
      let sumPrice = 0;
      if (quantity !== "") {
        sumPrice = quantity * price;
      }
      return sumPrice.toFixed(2);
    },
    netpriceTakingMedicine(item) {
      let netprice = 0;
      item.forEach((ele) => {
        if (ele.medicine_name !== "" && ele.quantity !== "") {
          netprice += Number(ele.quantity) * Number(ele.price);
        }
      });
      return netprice.toFixed(2);
    },

    configHeader(confer) {
      // console.log(confer);
      if (confer) return this.config["header-product"];
      return this.config["header-product-no-con"];
    },
    // conference เเพทย์
    async PhysicalExamOpen(patientDetil) {
      try {
        // this.setDetailPhysicalExam(item)
        await this.setQueueConference(patientDetil);
        const { patient_id } = patientDetil;
        const body = {
          // type_call: "Telemed",
          // patient_id: patient_id,
          // biz_id: sessionStorage.biz_id,
          // appointment_id: patientDetil.appointment_id,
          // receiver_oneid: patient_id,
          // sender_oneid: sessionStorage.account_id,
          send_by: {
            one_id: sessionStorage.oneId,
            role: sessionStorage.role_name,
          },
          type_call: "Telemed",
          patient_id: patient_id,
          biz_id: sessionStorage.biz_id,
          appointment_id: patientDetil.appointment_id,
          receiver_oneid: patient_id,
          sender_oneid: sessionStorage.oneId,
        };

        await Swal.fire({
          title:
            "<span style='color: black;font-size: 28px;font-family: Sarabun;font-weight: 500;'><b>ท่านต้องการ Video Conference </b></span>",
          html: `<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;padding-bottom: 20px; display: inline-block;'>คุณ ${patientDetil.patient_name} หรือไม่?</span>`,
          icon: "warning",
          showCancelButton: true,
          cancelButtonText:
            "<span style='font-size: 16px;font-family: Sarabun, sans-serif'>ยกเลิก</span>",
          showConfirmButton: true,
          confirmButtonText:
            "<span style='font-size: 16px;font-family: Sarabun, sans-serif;'>ยืนยัน</span>",
          cancelButtonColor: "#F5222D",
          confirmButtonColor: "#00A99D",
          allowOutsideClick: false,
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.LoadingData = true;
            setTimeout(() => {
              this.LoadingData = false;
            }, 2000);
            //เช็ค biz Kasemrad
            if (this.check_biz_kasemrad == "668236676897760") {
              const { data: { result, data } = {} } = await this.axios.post(
                `${process.env.VUE_APP_BACKEND_URL}/v1/conferences/create-conference`,
                body
              );
              if (result == "success") {
                await this.setDetailConference({ conference_url: data });
                this.$refs.ConferenceKasemrad.openDialog();
                // this.$router.push({ name: "ConfereceKasemrat" });
              }
            } else {
              const { data: { result, data } = {} } = await this.axios.post(
                `${process.env.VUE_APP_BACKEND_URL}/v1/conferences/create-conference`,
                body
              );
              if (result == "success") {
                await this.setDetailConference({ data: data });
                this.$refs.ConferenceTelemed.openDialog();
                //this.$router.push({ name: "ConferenceTelemed" });
              }
            }
          }
        });
      } catch (error) {
        if (error.response.data.message == "Unable to call oneself.") {
          Swal.fire({
            icon: "error",
            title:
              "<span style='color: black;font-size: 28px;font-family: Sarabun;font-weight: 500;'><b>ไม่สามารถ Conference ได้</b></span>",
            html: `<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;margin-top: 15px; display: inline-block;'>เนื่องจากท่านไม่สามารถ Conference หาตัวเองได้</span>`,
            showConfirmButton: false,
            timer: 2000,
          });
        } else {
          Swal.fire({
            icon: "error",
            title:
              "<span style='color: black;font-size: 28px;font-family: Sarabun;font-weight: 500;'><b>เกิดข้อผิดพลาด</b></span>",
            html: `<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;margin-top: 15px; display: inline-block;'>ไม่สามารถ Conference ได้</span>`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        console.error();
      }
      // this.$router.push({ name: "ConferenceDetail" });
    },
    // conference เภสัชกร
    async PharmacistOpen(patientDetil) {
      // this.setDetailPhysicalExam(item)
      // console.log("patientDetil", patientDetil);
      await this.setQueueConference(patientDetil);
      const { patient_id } = patientDetil;
      const params = {
        type_call: "Telemed",
        patient_id: patient_id,
        biz_id: sessionStorage.biz_id,
        appointment_id: patientDetil.appointment_id,
        receiver_oneid: patient_id,
        sender_oneid: sessionStorage.account_id,
      };
      try {
        const { data: { result, data } = {} } = await this.axios.post(
          `${process.env.VUE_APP_BACKEND_URL}/v1/conferences/create-conference`,
          params
        );

        if (result == "success") {
          // const data = {
          //   data,
          //   patient_name: `${data.patient.account_title_th} ${data.patient.first_name_th} ${data.patient.last_name_th}`,
          // };

          await this.setDetailConference({ data: data });
          this.$refs.ConferenceTelemed.openDialog();
        }
      } catch (error) {
        console.error();
      }
      // this.$router.push({ name: "ConferenceDetail" });
    },
    async getqueue() {
      try {
        this.LoadingData = true;
        var keyPat = this.itemsMember;
        if (keyPat === null || keyPat === undefined) {
          keyPat = "";
        } else keyPat = this.itemsMember.one_id;
        // console.log(this.itemsDoctor, this.itemsMember);
        var doctorKey = "";
        if (this.itemsDoctor === undefined || this.itemsDoctor === null) {
          doctorKey = "";
        } else {
          doctorKey = this.itemsDoctor.one_id;
        }
        const params = new URLSearchParams();
        // params.append("clinic_id", "06");
        params.append("date", this.filter.time || "");
        params.append("status", this.status);
        params.append("patient_id", keyPat);
        params.append("limit", 10);
        params.append("page", this.page);
        params.append("doctor_id", doctorKey);
        params.append("biz_id", sessionStorage.biz_id);
        // params.append("status_drug", this.drug_status);
        await this.axios
          .get(`${process.env.VUE_APP_BACKEND_URL}/v1/appointment?${params}`)
          .then((res) => {
            if (res.data.code == 200 && res.data.result == "success") {
              // this.selectedItem = res.data.data.appointment.data;
              this.itemsQ = res.data.data.appointment.data;
              if (this.itemsQ.length !== 0 && "_id" in this.itemsQ[0]) {
                this.selectedItem = this.itemsQ[0]._id;
                this.slotTime(this.itemsQ[0]);
              } else {
                this.selectedItem = [];
              }
              this.summaryQ = res.data.data.summary;
              if (this.summaryQ !== null) {
                let check_total = res.data.data.appointment.metadata;
                if (check_total.length !== 0) {
                  this.queueTotal =
                    res.data.data.appointment.metadata[0].total || 0;
                } else {
                  this.queueTotal = 0;
                }
              }
            }
            this.LoadingData = false;
          });
      } catch (error) {
        console.log(error);
        this.LoadingData = false;
      }
    },
    changeDate() {
      var year1 = "";
      var year2 = "";
      year1 = moment(this.filter.time).locale("th").format("YYYY");
      year2 = (parseInt(year1) + 543).toString();
      this.date_text = moment(this.filter.time)
        .locale("th")
        .format("DD/MM/" + year2);
      this.day_menu = false;
      this.page = 1;
      this.getqueue();
    },
    clearDate() {
      this.filter.time = "";
      this.page = 1;
      this.getqueue();
    },
    successCon() {
      this.status = "finish";
      this.getqueue();
    },

    changePage(page) {
      this.page = page;
      this.getqueue();
    },
    appointment_Response() {
      this.addAppointment = true;
    },
    check_conference(date) {
      if (date) {
        const value_check = new Date(date).getTime();
        const date_now = moment().format("YYYY-MM-DD");
        const time_now = new Date(date_now).getTime();
        if (value_check < time_now) {
          return false;
        } else {
          return true;
        }
      }
    },
    async checkIn(patientDetil) {
      try {
        // let title = "";
        let text = "";
        switch (patientDetil.status) {
          case "confirm":
            // title = "ต้องการเปลี่ยนสถานะเป็นพบแพทย์หรือไม่";
            text = "เปลี่ยนสถานะเป็นพบแพทย์หรือไม่";
            break;
          case 2:
            // title = "จบการรักษาหรือไม่?";
            text = "ต้องการให้คนไข้จบการรักษาหรือไม่?";
            break;
        }

        await Swal.fire({
          title:
            "<span style='color: black;font-size: 24px;font-family: Sarabun;font-weight: 500;'><b>ต้องการเปลี่ยนสถานะเป็นพบแพทย์หรือไม่</b></span>",
          html: `<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;padding-bottom: 20px; display: inline-block;'>คุณ ${text} หรือไม่?</span>`,
          // title: title,
          // text: text,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#00A99D",
          cancelButtonColor: "#d33",
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
        }).then((result) => {
          if (result.isConfirmed) {
            patientDetil.status == "confirm"
              ? (this.numStatus = "conference")
              : patientDetil.status == "conference"
              ? (this.numStatus = "finish")
              : "";
            this.axios
              .put(
                `${process.env.VUE_APP_BACKEND_URL}/v1/appointment?appointment_id=${patientDetil.appointment_id}`,
                {
                  status: this.numStatus,
                }
              )
              .then(async () => {
                if (this.numStatus == "conference") {
                  this.activeGet(2);
                } else if (this.numStatus == "finish") {
                  this.activeGet(3);
                } else if (this.numStatus == "drug") {
                  this.activeGet(5);
                }
              });
          }
        });
      } catch (error) {
        console.error();
      }
    },
    async Skip(patientDetil) {
      try {
        let title = "";
        let text = "";
        switch (patientDetil.status) {
          case "confirm":
            title = "ต้องการข้ามขั้นตอนการซักประวัติหรือไม่";
            text = "ข้ามขั้นตอนการซักประวัติหรือไม่";
            break;
          case 2:
            title = "จบการรักษาหรือไม่?";
            text = "ต้องการให้คนไข้จบการรักษาหรือไม่?";
            break;
        }

        await Swal.fire({
          title: title,
          text: text,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
        }).then((result) => {
          if (result.isConfirmed) {
            patientDetil.status == "confirm"
              ? (this.numStatus = "conference")
              : patientDetil.status == "conference"
              ? (this.numStatus = "finish")
              : "";
            this.axios
              .put(
                `${process.env.VUE_APP_BACKEND_URL}/v1/appointment?appointment_id=${patientDetil.appointment_id}`,
                {
                  status: this.numStatus,
                }
              )
              .then(async () => {
                if (this.numStatus == "conference") {
                  this.activeGet(2);
                } else if (this.numStatus == "finish") {
                  this.activeGet(3);
                } else if (this.numStatus == "drug") {
                  this.activeGet(5);
                }
              });
          }
        });
      } catch (error) {
        console.error();
      }
    },
    dialogError(text) {
      Swal.fire({
        type: "error",
        imageUrl: `${require("@/assets/icon/weather_R.png")}`,
        imageWidth: 200,
        imageHeight: 200,
        html: `${text}`,
        showCloseButton: false,
        showConfirmButton: false,
        background: "white",
        position: "center",
        timer: 1000,
        backdrop: false,
      });
    },
    getPatients(text) {
      try {
        // this.findUser =  []
        // let data_user = [];
        let limit = 1000;
        let word = "";
        if (text === undefined) {
          word = "";
        } else word = text.target.value;
        this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/patients/search?biz_id=${sessionStorage.biz_id}&search=${word}&limit=${limit}`
          )
          .then((res) => {
            // if (res.data.code == 200 && res.data.result == "success") {
            //   this.findUser = res.data.data[0].data;

            //   // data_user = res.data.data[0].data;
            //   // this.findUser = data_user.filter(
            //   //   (item) => item.one_id !== null && item.one_id !== undefined
            //   // );
            // }
            const getdata = res.data.data[0];
            if (getdata.data.length != 0) {
              this.findUser = [];
              getdata.data.forEach((ele) => {
                this.findUser.push({
                  text: ele.first_name_th + " " + ele.last_name_th,
                  mobile: ele.mobile,
                  value: ele,
                });
              });
            }
          });
      } catch (error) {
        console.error();
      }
    },

    searchAllDoctor(text) {
      try {
        let word = "";
        if (text === undefined) {
          word = "";
        } else word = text.target.value;
        this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/staffs/${sessionStorage.biz_id}?search=${word}&role=แพทย์&limit=100`
          )
          .then(async (res) => {
            if (res.data.code == 200 && res.data.result == "success") {
              this.findDoctor = res.data.data[0].data;
            }
          });
      } catch (error) {
        console.error();
      }
    },
    searchDoctor(key) {
      try {
        let Today = moment(new Date()).format("YYYY-MM-DD");
        this.itemAppointment = [];
        this.countData = 0;
        this.countData1 = 0;
        this.countData2 = 0;
        this.total = 0;

        this.axios
          .get(
            `${process.env.VUE_APP_BASE_URL}/search-doctor?keyword=${key}&dentist_clinic_id=06`,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.one_access_token}`,
              },
            }
          )
          .then(async (res) => {
            await this.$store.dispatch("actionLog", {
              action: "search Doctor",
              action_by: sessionStorage.account_id,
              path: `/search-doctor`,
              params: {
                keyword: key,
                dentist_clinic_id: "06",
              },
              header: {
                Authorization: `Bearer ${sessionStorage.one_access_token}`,
              },
            });

            let dentist = res.data.result;
            this.axios
              .get(
                `${process.env.VUE_APP_BASE_URL}/queue?dentist_id=${
                  dentist[0].dentist_id || ""
                }&start_time=${Today}`,
                {
                  headers: {
                    Authorization: `Bearer ${sessionStorage.one_access_token}`,
                  },
                }
              )
              .then(async (res) => {
                await this.$store.dispatch("actionLog", {
                  action: "search Doctor",
                  action_by: sessionStorage.account_id,
                  path: `/queue`,
                  params: {
                    dentist_id: dentist[0].dentist_id || "",
                    start_time: Today,
                  },
                  header: {
                    Authorization: `Bearer ${sessionStorage.one_access_token}`,
                  },
                });
                if (res.data.message === "success") {
                  this.itemAppointment = res.data.data;
                  res.data.data.forEach((element) => {
                    if (element.stage == 1) this.countData += 1;
                    if (element.stage == 2) this.countData1 += 1;
                    if (element.stage == 3) this.countData2 += 1;
                    if (element.stage) this.total += 1;
                  });
                }
              });
          });
      } catch (error) {
        console.error();
      }
    },
    resetData() {
      this.addAppointmentDialog = false;
      Object.keys(this.paramAppointment).forEach((element) => {
        if (element === "clinicId") {
          this.paramAppointment[element] = this.$cookies.get("me").clinicId;
        } else if (element === "time") {
          this.paramAppointment[element] = moment(new Date()).format(
            "YYYY-MM-DD"
          );
        } else this.paramAppointment[element] = "";
      });
    },
    activeGet(e) {
      this.page = 1;
      if (e === 0) {
        this.status = "";
        this.tab = "HistoryTalkingMain";
        this.patientDetil = "";
        this.getqueue();
        // this.filter_status(0)
      }

      if (e === 1) {
        this.tab = "HistoryTalkingMain";
        this.status = "confirm";
        this.patientDetil = "";
        this.getqueue();
        // this.filter_status(-1)
      }
      if (e === 2) {
        if (this.check_biz_kasemrad == "668236676897760") {
          this.tab = "HistoryTakingKasemrad";
        } else {
          this.tab = "HistoryTalkingMain";
        }
        this.status = "conference";
        this.patientDetil = "";
        this.getqueue();
        // this.filter_status(1)
      }
      if (e === 3) {
        this.tab = "HistoryTalkingMain";
        this.status = "finish";
        this.patientDetil = "";
        this.getqueue();
        // this.filter_status(3)
      }
      if (e === 5) {
        this.status = "drug";
        this.tab = "MedicinePatient";
        this.patientDetil = "";
        this.getqueue();
        // this.filter_status(4)
      }
    },
    textstatus(item) {
      if (
        item.status == "confirm" &&
        item.status !== "drug" &&
        item.payment_success == true &&
        this.check_biz_kasemrad !== "668236676897760"
      ) {
        return { text: "รอพบแพทย์", color: "text-F9C74F" };
      }
      if (
        item.status == "confirm" &&
        item.status !== "drug" &&
        item.payment_success == true &&
        this.check_biz_kasemrad == "668236676897760"
      ) {
        return { text: "ซักประวัติ", color: "text-336AB4" };
      }
      if (
        item.status == "confirm" &&
        item.status !== "drug" &&
        item.payment_success == false
      ) {
        return { text: "รอชำระเงิน", color: "text-F9C74F" };
      }
      if (item.status == "conference" && item.status !== "drug") {
        return { text: "พบแพทย์", color: "text-336AB4" };
      }
      if (item.status == "finish" && item.status !== "drug") {
        return { text: "จบการรักษา", color: "text-43AA8B" };
      }
      // if (status == "drug" && status_drug == "return") {
      //   return { text: "ส่งคืนเเก้ไขยา", color: " text-336AB4" };
      // }
      // if (status == "drug" && status_drug == "pending") {
      //   return { text: "รอตรวจสอบยา", color: " text-336AB4" };
      // }
      // if (status == "drug" && status_drug == "confirm") {
      //   return { text: "ตรวจสอบยาเสร็จสิ้น", color: " text-336AB4" };
      // }
      if (item.status == "drug") {
        return { text: "รอรับยา", color: "text-FFA07A" };
      }
    },
    textdrugstatus(status, drugstatus) {
      if (drugstatus.drugs == undefined) {
        return { text: "", color: " " };
      } else {
        if (status === 5 && drugstatus.drugs.status == "1") {
          return { text: "รอตรวจสอบยา", color: "text-F9C74F" };
        }
        if (status === 5 && drugstatus.drugs.status == "2") {
          return { text: "ส่งคืนแก้ไข", color: "text-336AB4" };
        }
        if (status === 5 && drugstatus.drugs.status == "3") {
          return { text: "ยืนยันการส่งยา", color: " text-43AA8B" };
        } else {
          return { text: "", color: " " };
        }
      }
    },
    async slotTime(item) {
      try {
        if (item) {
          this.setAppointmentDetail(item);
        }
        this.patientDetil = item;
        const params = new URLSearchParams();
        // params.append("clinic_id", "06");
        params.append("biz_id", sessionStorage.biz_id);
        params.append("search", item.patient_id);
        params.append("limit", 100);
        params.append("page", 1);
        // params.append("status_drug", this.drug_status);

        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/diagnostic-histories/patient?${params}`
          )
          .then(async (res) => {
            if (
              res.data.result == "success" &&
              res.data.data[0].data.length !== 0
            ) {
              var patient = res.data.data[0].data;
              // console.log("🚀 ~ file: e-vaccineMain.vue:2021 ~ .then ~ patient:", patient)
              this.setQueueDetail(patient);
              const params = new URLSearchParams();
              params.append("page", this.page || 1);
              params.append("limit", 10);
              // params.append("biz_id", sessionStorage.biz_id);
              params.append("search", item.appointment_id);

              const { data: { data, result } = {} } = await this.axios.get(
                `${process.env.VUE_APP_BACKEND_URL}/v1/diagnostic-histories/patient?${params}`
              );
              if (result == "success") {
                if (data[0]) {
                  this.itemDrug = [];
                  // console.log(data[0]);
                  const { data: searchData } = data[0];
                  // const { total } = metadata[0];
                  // this.total = total;
                  if (searchData[0]) {
                    this.itemHistory = searchData[0];
                  } else {
                    this.itemHistory = undefined;
                  }
                  if (this.itemHistory !== undefined) {
                    searchData.forEach((element) => {
                      this.itemDrug.push({
                        id: element._id,
                        drug: element.drug_list,
                      });
                    });
                    this.setItemDrug(this.itemDrug);
                    this.setItemHistory(this.itemHistory);
                  } else {
                    this.setItemHistory({ drug_list: [], history: false });
                  }
                  this.setTotal(this.total);
                }
              }
            } else {
              let data_queue = [];
              this.setQueueDetail(data_queue);
            }
          });
        // ข้อมูลการซักประวัติ
        const body = new URLSearchParams();
        body.append("appointment_id", item.appointment_id);
        await this.axios
          .get(`${process.env.VUE_APP_BACKEND_URL}/v1/historyTaking?${body}`)
          .then((res) => {
            if (res.data.result == "success") {
              let historyTaking = res.data.data;
              this.setHistoryTaking(historyTaking);
            }
          });
      } catch (error) {
        console.error();
      }
    },
    changeComponent(page) {
      this.tabPage = page;
    },
    showtextConference(size = "lg") {
      if (size === "xs") return false;
      return true;
    },
    createFileMedical(item) {
      this.createFileMedicalItem = {};
      this.openFileMedical = true;
      this.comment = "";
      this.createFileMedicalItem = item;
    },
    // changMedicine(index, item) {
    //   if (item) {
    //     this.takingMedicine[index].price = item.price;
    //     this.takingMedicine[index].medicine_name = item.name_drug;
    //     this.takingMedicine[index].medicine = item;
    //   }
    // },
    // removeDrug(index) {
    //   this.takingMedicine.splice(index, 1);
    // },

    sendEditDrugDialog(item) {
      this.$refs.SendEditMedicine.openDialog(item);
    },
    ConfirmDrugDeliveryDialog(item) {
      this.$refs.ConfirmDrugDelivery.openDialog(item);
    },
    async get_data_cert(item) {
      // ออกใบรับรองแพทย์หลัง Conference
      try {
        // console.log('item:', item)
        this.med_cert_dialog = true;
        const params = new URLSearchParams();
        params.append("biz_id", item.biz_id);
        params.append("doc_type", "MEDICAL_CERTIFICATE");
        params.append("patient", item.patient_id);
        params.append("doctor", item.doctor_id);
        params.append("mode", "telemedicine");
        await this.axios
          .get(`${process.env.VUE_APP_BACKEND_URL}/v1/dataCert?${params}`)
          .then((res) => {
            this.patient_med_cert = res.data.data;
          })
          .catch((err) => {
            console.log("axios get data cert error:", err.message);
          })
          .finally(() => {});
      } catch (error) {
        console.log("function create med cert error:", error);
      }
    },
    async add_med_cert() {
      try {
        await this.axios
          .post(`${process.env.VUE_APP_BACKEND_URL}/v1/addTransaction`, {
            payload: this.patient_med_cert,
            doc_code: "MEDICAL_CERTIFICATE",
            doc_name: "ใบรับรองแพทย์",
            create_by: sessionStorage.getItem("role_name"),
          })
          .then(async (res) => {
            this.med_cert_dialog = false;
            if (res.data.result === "success") {
              this.$swal.fire({
                icon: "success",
                title: `<span style="font-size: 20px;">ขอเอกสารสำเร็จ</span>`,
                showConfirmButton: false,
                timer: 2000,
              });
              await this.create_pdf(res.data.data);
            }
          });
      } catch (err) {
        console.log(err);
      }
    },
    async create_pdf(new_trans) {
      // console.log('new_trans:', new_trans)
      // console.log(this.select_doc)
      this.text_loading = "กำลังสร้างเอกสาร";
      this.loading_btn = true;
      new_trans.payload.patient.patient_address =
        await this.reformat_patient_address(
          new_trans.payload.patient.patient_address
        );
      new_trans.payload.patient.patient_id_card_number = functioncryto.decrypt(
        new_trans.payload.patient.patient_id_card_number
      );
      await this.axios
        .post(`${process.env.VUE_APP_BACKEND_URL}/v1/sign/create-med-cert`, {
          payload: new_trans.payload,
          sign_position: 2.2,
          doc_code: new_trans.doc_code,
          doc_name: new_trans.doc_name,
          pageToSign: 1,
          biz_id: new_trans.biz_id,
          request_date: new_trans.request_date,
          health_check_date: new_trans.health_check_date,
          file_id: "",
          status: "request",
        })
        .then(async (res) => {
          // console.log(res)
          this.loading_btn = false;
          if (res.data.result == "success") {
            let item = {
              id: new_trans._id,
              doc_code: new_trans.doc_code,
              pdf_data: res.data.data,
              doctor_name: new_trans.payload.doctor.doctor_name,
              cid: functioncryto.encrypt(
                new_trans.payload.patient.patient_id_card_number
              ),
            };
            if (sessionStorage.role_name === "แพทย์") {
              // console.log('sign med cert')
              await this.sign_med_cert(item);
            }
          }
        })
        .catch((err) => {
          this.loading_btn = false;
          console.log("err:", err.message);
        });
    },
    async update_appointment() {
      try {
        let payload = this.itemsQ[0];
        payload.med_cert = true;
        await this.axios.put(
          `${process.env.VUE_APP_BACKEND_URL}/v1/appointment?appointment_id=${this.patientDetil.appointment_id}`,
          payload
        );
      } catch (error) {
        console.log("error:", error.message);
      }
    },
    async sign_med_cert(item) {
      // console.log('item:', item)
      try {
        this.text_loading = "กำลังเซ็นเอกสาร";
        this.loading_dialog = true;
        await this.axios
          .post(`${process.env.VUE_APP_BACKEND_URL}/v1/sign/pdfdata`, {
            id: item.id,
            doc_code: item.doc_code,
            biz_id: sessionStorage.biz_id,
            cid: item.cid,
            pdf_data: item.pdf_data,
            pageToSign: 1,
            sign_position: `${
              (Math.ceil(this.countThaiTextLength(item.doctor_name) / 2) / 10 +
                2.5) /
              8.3
            },0.09,0.421,0.087`,
            doctor_one_id: sessionStorage.account_id,
            patient_name: this.itemsQ[0].patient_name,
          })
          .then(async (res) => {
            this.loading_dialog = false;
            if (res.data.result === "success") {
              this.$swal.fire({
                icon: "success",
                title: `<span style="font-size: 20px;">เซ็นเอกสารสำเร็จ</span>`,
                showConfirmButton: false,
                timer: 2000,
              });
              await this.update_appointment();
            }
          });
      } catch (err) {
        this.loading_dialog = false;
        if (err.response.data.message === "Not found credential") {
          this.$swal.fire({
            icon: "error",
            title: `<span style="font-size: 20px;">ไม่มีสิทธ์ในการเซ็นเอกสาร</span>`,
            showConfirmButton: false,
            timer: 2000,
          });
        } else if (err.response.data.message == "Patient not found") {
          this.$swal.fire({
            icon: "error",
            title: `<span style="font-size: 20px;">ไม่พบ oneid ของผู้ป่วย</span>`,
            showConfirmButton: false,
            timer: 2000,
          });
        } else if (
          err.response.data.message == "This user has not a signature image!!"
        ) {
          this.$swal.fire({
            icon: "error",
            title: `<span style="font-size: 20px;">ไม่พบลายเซ็นแพทย์ ไปที่ตั้งค่า</span>`,
            showConfirmButton: false,
            timer: 2000,
          });
        } else {
          this.$swal.fire({
            icon: "error",
            title: `<span style="font-size: 20px;">เกิดข้อผิดพลาด</span>`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        console.log(err);
      }
    },
    async reformat_patient_address(item_address) {
      const addressParts = [];

      for (const [key, value] of Object.entries(item_address)) {
        if (value) {
          if (key === "houseNo") {
            addressParts.push("บ้านเลขที่ " + value);
          } else if (key === "moo") {
            addressParts.push("หมู่ที่ " + value);
          } else if (key === "soi") {
            addressParts.push("ซอย " + value);
          } else if (key === "amphur") {
            addressParts.push("อำเภอ/เขต " + value);
          } else if (key === "tambon") {
            addressParts.push("ตำบล/แขวง " + value);
          } else if (key === "province") {
            addressParts.push("จังหวัด " + value);
          } else if (key === "zipcode") {
            addressParts.push("รหัสไปรษณีย์ " + value);
          }
        }
      }

      const address = addressParts.join(" ");
      return address;
    },

    countThaiTextLength(text) {
      const pattern = /[\u0E01-\u0E2Eะาเโไแำๅ\s]/g; // Unicode range for Thai characters and space
      const excludedVowels = /[\u0E31\u0E34-\u0E3A]/; // Excluded vowels pattern
      let arr = text.split(" ");
      let text2 = `${arr[0]} ${arr[1]}`;
      const match = text2.match(pattern);
      let count = 0;

      if (match) {
        match.forEach((character) => {
          if (!excludedVowels.test(character)) {
            count++;
          }
        });
      }

      return count;
    },
    shouldShowDrugAction(itemHistory, status, biz_id) {
      if (!itemHistory || !("status_drug" in itemHistory)) return false;

      const isDrugStatus = status === "drug";
      const isPending = itemHistory.status_drug === "pending";
      const isPharmacist = this.role_name === "เภสัชกร";

      const isWithBizBPI =
        this.role_name === "พยาบาล" && biz_id === "89236321740888275";
      const isWithBizPRB =
        this.role_name === "พยาบาล" && biz_id === "174289066019012";

      return (
        isDrugStatus &&
        isPending &&
        (isPharmacist || isWithBizBPI || isWithBizPRB)
      );

      // const isNurseWithBiz =
      //   this.role_name === "พยาบาล" && biz_id === "324265892276395";

      // return isDrugStatus && isPending && (isPharmacist || isNurseWithBiz);
    },
  },
};
</script>

<style scoped>
.stycard {
  /* bg */
  position: absolute;
  /* white */
  background: #fbfffe;
  border-radius: 80px 0px 0px 0px;
}

::v-deep .mx-input {
  border-radius: 20px 5px;
}

::v-deep .input.mx-input {
  background: #ceefed;
  border-radius: 20px 5px;
}
.table-viewdoc th {
  background: #ceefed !important;
  color: #00a99d !important;
}
#app {
  background-color: #eff6fc;
}
::v-deep .vue__time-picker > input.display-time {
  border: 1px solid #d2d2d2;
  width: 100%;
  /* height: 2.4em; */
  /* padding-right: 23px !important; */
  /* font-size: 1em; */
  border-radius: 4px;
}
.pr-6 {
  padding-right: 20px;
}
.container.fill-height {
  align-items: start;
}

.set-border-content {
  border-bottom: 1px solid #e5e5e5;
}

.set-badge {
  border: 1px solid #336ab4;
  border-radius: 4px;
  background: rgba(12, 117, 213, 0.05);
}

::v-deep .v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none;
}

.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
  height: 32px;
}

.set-border-span {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  min-height: 32px;
  box-shadow: none;
  border: 1px solid #ebeef3;
}
.icon-card {
  /* margin-top: 8px; */
  /* margin-left: 42px; */
  width: 56px;
  height: 56px;
}

::v-deep .v-list-item--link:before {
  /* border-radius: 5px; */
  background-color: #00ad9f;
}

::v-deep .v-tabs-slider-wrapper {
  height: 5px !important;
  border-radius: 5px !important;
}

.card_pr {
  padding-right: 12px;
}

::v-deep .v-pagination__more {
  margin: 0.3rem;
  display: inline-flex;
  align-items: flex-end;
  justify-content: center;
  height: 32px;
  width: 16px;
  font-size: 10px !important;
}

::v-deep .v-pagination__navigation {
  background: #ffffff !important;
  color: #09425a;
  height: 25px !important;
  width: 20px !important;
  font-size: 10px !important;
}

::v-deep .v-pagination__item {
  min-width: 14px !important;
  font-size: 12px !important;
  height: 25px !important;
  width: 20px !important;
  padding: 0px !important;
}

::v-deep .v-pagination__item .v-pagination__item--active .primary {
  background-color: #23f250 !important;
  border-color: #f703ffe1 !important;
}

::v-deep .mx-input {
  height: 38px !important;
  border: 1px solid #ebeef3;
}

/* .theme-back-text {
  color: #ffffff;
  font-size: 18px;
  padding-left: 0px;
} */

/* .theme-light-text {
  color: #00a99d;
  font-size: 18px;
  padding-left: 0px;
} */

.card-medium {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.card-medium-cancel {
  border-radius: 20px 5px;
  box-shadow: none !important;
}

.icon-dark {
  background: #ceefed;
  border-radius: 16px 5px;
  padding: 5px;
}
.icon-light {
  background: #00a99d;
  border-radius: 16px 5px;
  padding: 5px;
}

::v-deep .v-image__image--cover {
  background-size: auto;
}

@media screen and (max-width: 960px) {
  .card_pr {
    padding-right: 0px;
  }
}

@media screen and (max-width: 600px) {
  .xs_font {
    /* visibility: hidden; */
    font-size: 15px;
  }
}
.mx-datepicker {
  width: 100%;
}
.v-btn-add {
  border-style: solid;
  border-color: linear-gradient(213.66deg, #16b4eb 4.85%, #23e73c 119.17%);
}
.theme-background {
  background-color: #00a99d;
  color: #ffffff;
}
.v-list-item-group .v-list-item--active {
  color: #061b2e;
  background: #afeeee;
}
/* .icon-card {
  margin-top: 8px;
  margin-left: 22px;
  width: 24px;
  height: 24px;
} */
/* ::v-deep.v-autocomplete {
width: 189px!important;
height: 40px;
border-radius: 4px;
} */
::v-deep.v-input__slot {
  margin-right: 0px !important;
}
::v-deep.druglist {
  margin-left: 4.1%;
}

::v-deep .v-responsive {
  flex: none !important;
}

.card-small {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}

::v-deep .v-input input {
  line-height: 1.8rem;
  text-indent: 4px;
}
::v-deep .v-list-item .v-list-item__title,
.v-list-item .v-list-item__subtitle {
  line-height: 1.8rem !important;
}
</style>
